export default "__VITE_ASSET__f74ad298__"